import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import store from './redux/store';
import ProviderGeneral from './providers/root.provider';

ReactDOM.render(
  <Provider store={store}>
    <ProviderGeneral>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ProviderGeneral>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();